/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_shorts_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I download a YouTube Shorts thumbnail?`)
};

const es_yt_shorts_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo descargar la miniatura de un YouTube Short?`)
};

const de_yt_shorts_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich das Thumbnail eines YouTube Shorts herunterladen?`)
};

const nl_yt_shorts_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik de thumbnail van een YouTube Short downloaden?`)
};

const fr_yt_shorts_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je télécharger la miniature d’un YouTube Short ?`)
};

const it_yt_shorts_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso scaricare la miniatura di uno YouTube Short?`)
};

const pt_br2_yt_shorts_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso baixar a thumbnail de um YouTube Shorts?`)
};

const pt_yt_shorts_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso descarregar a miniatura de um YouTube Shorts?`)
};

const ja_yt_shorts_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube Shortsのサムネイルをダウンロードできますか？`)
};

const zh_yt_shorts_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我可以下载 YouTube Shorts 的缩略图吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_shorts_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_shorts_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_shorts_faq1_q", locale)
	if (locale === "en") return en_yt_shorts_faq1_q(inputs)
	if (locale === "es") return es_yt_shorts_faq1_q(inputs)
	if (locale === "de") return de_yt_shorts_faq1_q(inputs)
	if (locale === "nl") return nl_yt_shorts_faq1_q(inputs)
	if (locale === "fr") return fr_yt_shorts_faq1_q(inputs)
	if (locale === "it") return it_yt_shorts_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_yt_shorts_faq1_q(inputs)
	if (locale === "pt") return pt_yt_shorts_faq1_q(inputs)
	if (locale === "ja") return ja_yt_shorts_faq1_q(inputs)
	return zh_yt_shorts_faq1_q(inputs)
};